import draftToHtml from "draftjs-to-html";
import { convertToRaw, ContentState } from "draft-js";
import htmlToDraft from 'html-to-draftjs';

export const getHtml = editorState => {
  if (!editorState || typeof editorState.getCurrentContent !== "function") return "";
  try {
    return draftToHtml(convertToRaw(editorState.getCurrentContent()));
  } catch (e) {
    return "";
  }
};

export const getHtmlFromRaw = rawContent => {
  if (!rawContent) return "";
  if (typeof rawContent === "object" && typeof rawContent.getCurrentContent === "function") {
    return draftToHtml(convertToRaw(rawContent.getCurrentContent()));
  }
  if (!Array.isArray(rawContent.blocks)) return "";
  const hasText = rawContent.blocks.some(block => (block.text || "").trim() !== "");
  return hasText ? draftToHtml(rawContent) : "";
};

export const getRawData = editor => {
  if (!editor || typeof editor !== "string") {
    return ContentState.createFromText("");
  }
  try {
    const blocksFromHtml = htmlToDraft(editor);
    if (!blocksFromHtml || !blocksFromHtml.contentBlocks) {
      return ContentState.createFromText("");
    }
    const { contentBlocks, entityMap } = blocksFromHtml;
    return ContentState.createFromBlockArray(contentBlocks, entityMap);
  } catch (err) {
    return ContentState.createFromText("");
  }
};

export const dummyRequest = ({ onSuccess }) => {
  setTimeout(() => {
    onSuccess("ok");
  }, 0);
};